import { z } from "zod";
import { defineEvent } from "./registry.js";
const documentKind = z.enum(["INVOICE", "DESPATCH"]);
/** Yükler alıcı / satıcı adı, VKN-TCKN, adres TAŞIMAZ (KVKK); ayrıntı yetki denetimli API'den çekilir. */
export const invoiceIssuedV1 = defineEvent({
    type: "invoicing.invoice.issued",
    version: 1,
    description: "Fatura kesinleşti (satış / alış / iade); muhasebe fişi ve cari açık kalemi üretildi",
    realtime: ["tenant"],
    payload: z.object({
        invoiceId: z.uuid(),
        companyId: z.uuid(),
        stationId: z.uuid().nullable(),
        direction: z.enum(["SALES", "PURCHASE"]),
        flow: z.enum(["OUTGOING", "INCOMING"]),
        invoiceType: z.string(),
        scenario: z.string(),
        basis: z.enum(["STANDARD", "FISCAL_RECEIPTS"]),
        invoiceNo: z.string(),
        issueDate: z.iso.date(),
        counterpartyId: z.uuid(),
        payableAmount: z.string(),
        ledgerStatus: z.enum(["POSTED", "QUEUED", "NONE"]),
        edocumentStatus: z.string(),
    }),
});
export const invoiceCancelledV1 = defineEvent({
    type: "invoicing.invoice.cancelled",
    version: 1,
    description: "Fatura iptal edildi; fişin ters kaydı alındı, açık kalemler geçersiz kılındı",
    realtime: ["tenant"],
    payload: z.object({
        invoiceId: z.uuid(),
        companyId: z.uuid(),
        invoiceNo: z.string().nullable(),
        direction: z.enum(["SALES", "PURCHASE"]),
    }),
});
export const edocumentStatusChangedV1 = defineEvent({
    type: "invoicing.edocument.status_changed",
    version: 1,
    description: "e-Belge durumu değişti (kuyrukta, gönderildi, alıcıya ulaştı, kabul, red, raporlandı, iptal)",
    realtime: ["tenant"],
    payload: z.object({
        documentKind,
        documentId: z.uuid(),
        companyId: z.uuid(),
        documentNo: z.string().nullable(),
        previousStatus: z.string(),
        status: z.string(),
    }),
});
/** ALARM: gönderim kalıcı olarak başarısız oldu ya da tüm denemeler tükendi (alarm modülü bildirime çevirir, Prompt 20). */
export const edocumentFailedV1 = defineEvent({
    type: "invoicing.edocument.failed",
    version: 1,
    description: "e-Belge gönderilemedi; elle müdahale (düzeltme / yeniden gönderme) gerekir",
    realtime: ["tenant"],
    payload: z.object({
        documentKind,
        documentId: z.uuid(),
        companyId: z.uuid(),
        documentNo: z.string().nullable(),
        attempts: z.number().int(),
        errorCode: z.string().nullable(),
    }),
});
export const incomingInvoiceReceivedV1 = defineEvent({
    type: "invoicing.incoming.received",
    version: 1,
    description: "Sağlayıcıdan yeni gelen fatura alındı (gelen kutusu)",
    realtime: ["tenant"],
    payload: z.object({
        incomingInvoiceId: z.uuid(),
        companyId: z.uuid(),
        scenario: z.string(),
        payableAmount: z.string(),
        counterpartyId: z.uuid().nullable(),
        responseDueDate: z.iso.date().nullable(),
    }),
});
/** ALARM: ticari faturada kabul / red süresinin dolmasına az kaldı (son gün alarmı; fatura başına bir kez). */
export const incomingResponseDueV1 = defineEvent({
    type: "invoicing.incoming.response_due",
    version: 1,
    description: "Ticari gelen faturanın kabul / red süresi dolmak üzere",
    realtime: ["tenant"],
    payload: z.object({
        incomingInvoiceId: z.uuid(),
        companyId: z.uuid(),
        responseDueDate: z.iso.date(),
        daysLeft: z.number().int(),
        payableAmount: z.string(),
    }),
});
export const earchiveRequestedV1 = defineEvent({
    type: "invoicing.earchive.requested",
    version: 1,
    description: "Kasadan (POS) gün içi e-Arşiv fatura talebi geldi",
    realtime: ["tenant"],
    payload: z.object({
        requestId: z.uuid(),
        companyId: z.uuid(),
        stationId: z.uuid(),
        amount: z.string(),
        receiptDate: z.iso.date(),
    }),
});
//# sourceMappingURL=invoicing.v1.js.map